import { StyleSheet } from 'react-native';

import { COLOR, whiteTransparent } from 'utils/colors';

const styles = StyleSheet.create({
    root: {
        backgroundColor: COLOR.background,
        borderBottomWidth: 1,
        borderBottomColor: whiteTransparent(0.1),
        justifyContent: 'flex-end',
    },
    header: {
        height: 48,
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingHorizontal: 16,
    },
});

export default styles;
